module.exports = __webpack_public_path__ + "static/img/暂无手术信息@2x.9df3ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/ssjz/assets/暂无手术信息@2x.png
// module id = 293
// module chunks = 379 380